import { Alert } from '@mui/material';
import { propertyIdToPropertySelectorFamily } from '../../lib/property/state/PropertyRecoilState';
import { useRecoilValue } from 'recoil';

type PropertyArchivedAlertProps = {
    readonly propertyId: string;
};

export const PropertyArchivedAlert = (props: PropertyArchivedAlertProps) => {
    const { propertyId } = props;
    const property = useRecoilValue(propertyIdToPropertySelectorFamily(propertyId));

    return (
        <>
            {property?.isArchived &&
                <Alert severity="warning" variant='outlined' sx={{ my: 2 }}>
                    This property is archived. It will not be visible in the property list, but you can still access it by using the search bar.
                </Alert>
            }
        </>
    );
};